import type { PendingAbsenceEntity } from '@data/utils/types';
import React from 'react';

/** Today's time off from Officient, for the day cards below a timesheet page to show before it is filed. */
export const PendingAbsencesContext = React.createContext<PendingAbsenceEntity[]>([]);
